import React from 'react'
import styles from './styles'

const Hint = (props) => (
    <div className={`${styles.hint} ${props.className}`}>
      {props.children}
    </div>
  )


Hint.propTypes = {
  children: React.PropTypes.node,
  className: React.PropTypes.string,
}

export default Hint



// WEBPACK FOOTER //
// ./src/app/components/hint/index.jsx